module.exports = __webpack_public_path__ + "static/media/reward14.642f76d3.jpg";